import { FaArrowUp } from '@react-icons/all-files/fa/FaArrowUp';
import clsx from 'clsx';
import { useContext, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { useScrolled } from 'helpers';

import { LocaleContext } from './rebrand/Layout';

export const ScrollUpButton = () => {
  const locale = useContext(LocaleContext);
  const [visible, visibleSet] = useState(false);

  const scrolled = useScrolled();

  useEffect(() => {
    visibleSet(scrolled > window.innerHeight / 3);
  }, [scrolled]);

  return (
    <button
      className={twMerge(
        clsx(
          'pointer-events-none fixed bottom-122 left-10 z-belowNav flex h-32 w-32 items-center justify-center rounded-[50%] bg-white bg-opacity-50 text-primary-350 opacity-0 shadow-[0_2px_4px_rgba(0,0,0,0.1)] transition-opacity md:hidden',
          visible && 'pointer-events-auto opacity-100',
        ),
      )}
      onClick={() => {
        window.scrollTo && window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      aria-hidden={!visible}
      aria-label={
        {
          en: 'Click to scroll back to top of page',
          fr: 'Cliquez pour revenir en haut de la page',
        }[locale]
      }
      tabIndex={visible ? 0 : -1}
    >
      <FaArrowUp />
    </button>
  );
};
